'use client';

import { useEffect } from 'react';

const RELOAD_FLAG = 'chunk-load-recovered';

function isChunkLoadError(message: string) {
  return message.includes('ChunkLoadError') || message.includes('Loading chunk');
}

export default function ChunkErrorRecovery() {
  useEffect(() => {
    const recover = () => {
      try {
        if (sessionStorage.getItem(RELOAD_FLAG)) return;
        sessionStorage.setItem(RELOAD_FLAG, '1');
      } catch {
        // sessionStorage may be unavailable in some browsing modes.
      }

      window.location.reload();
    };

    const handleError = (event: ErrorEvent) => {
      const message =
        event?.error instanceof Error
          ? event.error.message
          : typeof event.message === 'string'
            ? event.message
            : '';

      if (isChunkLoadError(message)) {
        recover();
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const message = reason instanceof Error ? reason.message : String(reason ?? '');

      if (isChunkLoadError(message)) {
        recover();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
